// AUDIKIT — offre « 3 achetées = 1 offerte » (snippets/audikit-bundle-offer.liquid).
//
// Le choix d'une carte (1, 4 ou 8 boîtes) règle le champ quantité du thème, que
// « Ajouter au panier » lit ensuite comme d'habitude (product-form.js →
// quantitySelector.getValue()). Dans l'autre sens, si le client change la
// quantité avec + / − ou au clavier, la carte correspondante se coche, ou aucune
// si la quantité ne correspond à aucune offre.
//
// Le thème régénère la section par morph quand on change de variante (HF3
// droite / gauche) : la carte cochée revient alors à celle du HTML serveur. Un
// MutationObserver limité à la section la recale sur la quantité. Il suit aussi
// les attributs checked / value : le morph peut remettre la carte « 1 boîte »
// sans toucher à la structure. Minuteries plutôt que requestAnimationFrame, que
// le navigateur suspend dans un onglet masqué.
//
// Chargé sur toutes les pages par snippets/audikit-global-scripts.liquid, et non
// par l'encart lui-même : la fenêtre d'ajout rapide des pages collection recopie
// l'encart, mais un <script> recopié ainsi ne s'exécute jamais (5 oct. 2026).
// Tous les écouteurs sont délégués sur document, ils servent donc aussi dans la
// fenêtre.

const ROOT = '[data-ak-bundle]';

/** @param {Element} root */
function quantitySelectorOf(root) {
  const form = root.closest('product-form-component');
  return /** @type {any} */ (form?.querySelector('quantity-selector-component') ?? null);
}

/** @param {Element} root */
function quantityInputOf(root) {
  const form = root.closest('product-form-component');
  return /** @type {HTMLInputElement | null} */ (form?.querySelector('input[name="quantity"]') ?? null);
}

/**
 * @param {Element} root
 * @param {number} quantity
 */
function setQuantity(root, quantity) {
  const selector = quantitySelectorOf(root);
  const value = String(quantity);

  if (selector?.setValue) {
    selector.setValue(value);
    selector.updateButtonStates?.();
    selector.onQuantityChange?.();
    return;
  }

  const input = quantityInputOf(root);
  if (!input) return;
  input.value = value;
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

/** @param {Element} root */
function syncFromQuantity(root) {
  const input = quantityInputOf(root);
  if (!input) return;
  const quantity = input.value;

  root.querySelectorAll('input[type="radio"]').forEach((radio) => {
    if (radio instanceof HTMLInputElement) radio.checked = radio.value === quantity;
  });
}

document.addEventListener('change', (event) => {
  const radio = event.target;
  if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;
  const root = radio.closest(ROOT);
  if (!root || !radio.checked) return;

  // Un encart arrivé après le chargement (fenêtre d'ajout rapide) n'est pas
  // encore observé.
  watchSections();
  setQuantity(root, Number(radio.value) || 1);
});

// + / − et saisie au clavier : le composant met la valeur à jour sans événement
// « change » fiable, on relit donc la quantité juste après.
/** @param {Event} event */
function onQuantityInteraction(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;
  if (!target.closest('quantity-selector-component')) return;

  const form = target.closest('product-form-component');
  const root = form?.querySelector(ROOT);
  if (!root) return;

  setTimeout(() => syncFromQuantity(root), 0);
}

document.addEventListener('click', onQuantityInteraction);
document.addEventListener('focusout', onQuantityInteraction);
document.addEventListener('input', onQuantityInteraction);

/** @type {WeakSet<Element>} */
const observed = new WeakSet();

function watchSections() {
  document.querySelectorAll(ROOT).forEach((root) => {
    // La fenêtre d'ajout rapide d'abord : elle peut se trouver dans la section
    // de la collection, qu'on n'a pas à observer en entier.
    const section = root.closest('quick-add-dialog, .shopify-section');
    if (!section || observed.has(section)) return;
    observed.add(section);

    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      setTimeout(() => {
        scheduled = false;
        section.querySelectorAll(ROOT).forEach(syncFromQuantity);
      }, 0);
    }).observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'value'] });

    syncFromQuantity(root);
  });
}

watchSections();
